import { NgbDate } from '@cmps/ng-bootstrap';
import { addDays, isBefore, max } from 'date-fns';

import { CmpsDatePipe } from '../common/date.pipe';
import { CacheDateItem } from '../performance-data/cache-date.pd.model';
import { PeriodType } from '../widget/date-range.widget.model';

import { TranslationKeyMap } from './insight.i18n';

export const PeriodTypeOpts: Array<{ value: PeriodType; tlKey: string }> = [
    { value: PeriodType.DAY, tlKey: TranslationKeyMap._202_DAILY },
    { value: PeriodType.WEEK, tlKey: TranslationKeyMap._203_WEEKLY },
    { value: PeriodType.MONTH, tlKey: TranslationKeyMap._204_MONTHLY },
    {
        value: PeriodType.ROLLING_30,
        tlKey: TranslationKeyMap._7137__30_DAY_ROLLING,
    },
    { value: PeriodType.QUARTER, tlKey: TranslationKeyMap._205_QUARTERLY },
    { value: PeriodType.YEAR, tlKey: TranslationKeyMap._7132_YEARLY },
];

export const invalidEventDate = (
    periodType: PeriodType,
    cacheDates: CacheDateItem[],
): ((date: NgbDate, current: { year: number; month: number }) => boolean) => {
    const dates = cacheDates?.map((e) => e.eventDate);
    const periodTypeDayMin = addDays(
        dates != null ? max(dates) : new Date(),
        -90,
    );
    return (date: NgbDate, _: { year: number; month: number }) =>
        cacheDates &&
        cacheDates.findIndex((value) => {
            const d = value.eventDate;
            if (
                periodType === PeriodType.DAY &&
                isBefore(d, periodTypeDayMin)
            ) {
                return false;
            }
            return (
                d.getFullYear() === date.year &&
                d.getMonth() === date.month - 1 &&
                d.getDate() === date.day
            );
        }) === -1;
};

export type CanSelectEventDateFn = (eventDate: Date) => boolean;

export function getEventDateValue(
    cacheDates: CacheDateItem[],
    eventDate: Date,
    periodType: PeriodType,
    datePipe: CmpsDatePipe,
): string {
    if (!cacheDates) {
        return null;
    }
    const cacheDate = cacheDates.find(
        (e) =>
            e.eventDate &&
            eventDate &&
            e.eventDate.getTime() === eventDate.getTime(),
    );
    switch (periodType) {
        case PeriodType.DAY:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `${datePipe.transform(cacheDate.endDate, 'MMMM dd, y')}`;
        case PeriodType.MONTH:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `${datePipe.transform(
                cacheDate.startDate,
                'MMMM dd',
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            )} - ${datePipe.transform(cacheDate.endDate, 'MMMM dd, y')}`;
        case PeriodType.WEEK:
        case PeriodType.QUARTER:
        case PeriodType.YEAR:
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            return `${datePipe.transform(
                cacheDate.startDate,
                'MMMM dd, y',
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            )} - ${datePipe.transform(cacheDate.endDate, 'MMMM dd, y')}`;
    }
    return null;
}
